<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  article: Object,
});
const modules = [Pagination];
const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
};
</script>

<template>
  <div class="article-homepage">
    <div class="header">
      <div class="article-text">
        <h2>{{ article.title }}</h2>
        <div class="text" v-html="article.content"></div>
      </div>
      <div class="article-image">
        <div class="image">
          <img :src="article.featured_image.fullUrl" alt="">
        </div>
        <div class="title">
          <h3>Elétrico por Natureza,</h3>
        </div>
        <div class="text-mobile">
          <h3>Elétrico por Natureza, Rural por vocação</h3>
        </div>
      </div>
    </div>
    <div class="footer-slider">
      <div class="orange-overlay">
      </div>
      <div class="text-overlay">
        <h3>Rural por vocação</h3>
      </div>
      <swiper
        v-bind="swiperOptions"
        :pagination="{ clickable: true }"
        :modules="modules"
        class="mySwiper">
        <swiper-slide v-for="(image, index) in article.dynamicGalleries" :key="index">
          <div class="slide-card">
            <div class="image-wrapper">
              <img :src="image.fullUrl" :alt="'Slide ' + index"/>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style scoped>

</style>
